import { useEffect, useRef } from 'react';

/**
 * 趋势图表组件
 * 简单的 SVG 面积图展示近7天机会趋势
 */
export default function TrendChart({ data = [] }) {
  if (!data.length) {
    return (
      <div style={{
        padding: '40px 24px',
        textAlign: 'center',
        borderRadius: 16,
        background: 'rgba(255,255,255,0.015)',
        border: '1px solid rgba(255,255,255,0.04)',
      }}>
        <p style={{ fontSize: 13, color: '#64766D' }}>趋势数据加载中...</p>
      </div>
    );
  }

  const W = 800;
  const H = 120;
  const PAD = { top: 10, right: 10, bottom: 24, left: 10 };
  const plotW = W - PAD.left - PAD.right;
  const plotH = H - PAD.top - PAD.bottom;

  const maxCount = Math.max(...data.map(d => d.count || 0), 10);
  const maxScore = 100;

  // 路径计算
  const getX = (i) => PAD.left + (i / (data.length - 1)) * plotW;
  const getY = (val) => PAD.top + plotH - (val / maxCount) * plotH;
  const getScoreY = (val) => PAD.top + plotH - (val / maxScore) * plotH;

  const areaPath = data.reduce((path, d, i) => {
    const x = getX(i);
    const y = getY(d.count || 0);
    return path + (i === 0 ? `M${x},${y}` : ` L${x},${y}`);
  }, '') + ` L${getX(data.length - 1)},${PAD.top + plotH} L${PAD.left},${PAD.top + plotH} Z`;

  const linePath = data.reduce((path, d, i) => {
    const x = getX(i);
    const y = getY(d.count || 0);
    return path + (i === 0 ? `M${x},${y}` : ` L${x},${y}`);
  }, '');

  const scoreLinePath = data.reduce((path, d, i) => {
    const x = getX(i);
    const y = getScoreY(d.avgScore || 0);
    return path + (i === 0 ? `M${x},${y}` : ` L${x},${y}`);
  }, '');

  return (
    <div style={{
      padding: '24px',
      borderRadius: 16,
      background: 'rgba(255,255,255,0.015)',
      border: '1px solid rgba(255,255,255,0.04)',
    }}>
      {/* 图例 */}
      <div style={{
        display: 'flex', gap: 20, marginBottom: 12,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 12, height: 3, borderRadius: 2, background: '#E8C85A' }} />
          <span style={{ fontSize: 11, color: '#64766D' }}>机会数量</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 12, height: 3, borderRadius: 2, background: '#69B89A' }} />
          <span style={{ fontSize: 11, color: '#64766D' }}>平均指数</span>
        </div>
      </div>

      {/* SVG 图表 */}
      <svg
        viewBox={`0 0 ${W} ${H}`}
        preserveAspectRatio="xMidYMid meet"
        style={{ width: '100%', height: 'auto', display: 'block' }}>
        {/* 面积填充 */}
        <defs>
          <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgba(232,200,90,0.15)" />
            <stop offset="100%" stopColor="rgba(232,200,90,0)" />
          </linearGradient>
        </defs>
        <path d={areaPath} fill="url(#areaGrad)" />

        {/* 数量线 */}
        <path d={linePath} fill="none" stroke="#E8C85A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

        {/* 平均指数线 */}
        <path d={scoreLinePath} fill="none" stroke="#69B89A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4,4" />

        {/* 数据点 */}
        {data.map((d, i) => (
          <g key={i}>
            <circle cx={getX(i)} cy={getY(d.count || 0)} r="4" fill="#E8C85A" />
            <circle cx={getX(i)} cy={getY(d.count || 0)} r="7" fill="rgba(232,200,90,0.1)" />
            {/* X 轴标签 */}
            <text
              x={getX(i)}
              y={H - 6}
              textAnchor="middle"
              fontSize="9"
              fill="#64766D"
              fontFamily="var(--font-sans)"
            >
              {d.date}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
}
